import React, { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import CenteredSpinner from "@/shared/components/centered-spinner";

interface Props {
  isLoading: boolean;
  children: ReactNode;
  // 감싸는 영역이 작으면(체크박스 한 줄 등) 기본 스피너(30px)가 넘쳐 작게 둔다.
  spinnerSize?: number;
}

// 요청 중인 컨트롤 위에만 딤드와 스피너를 덮는다 — 목록 오버레이 스피너와 같은 표기.
// 딤드가 클릭도 막아 요청 중 중복 입력이 들어가지 않는다.
function PathPickLoadingDim({ isLoading, children, spinnerSize = 16 }: Props) {
  return (
    <Box position={"relative"} width={"fit-content"}>
      {children}
      {isLoading && (
        <Box
          position={"absolute"}
          inset={0}
          background={"rgba(255, 255, 255, 0.6)"}
        >
          <CenteredSpinner size={spinnerSize} />
        </Box>
      )}
    </Box>
  );
}

export default PathPickLoadingDim;
